import { MenuItem } from '@mui/material';
import { withAllow } from './hooks/withAllow';
import { withShowable } from '../console/_global/lib/withShowable';

const AllowedMenuItem = withAllow(withShowable(MenuItem));

export default AllowedMenuItem;
